export const genderOptions = [
  { value: "MASCULINO", label: "Masculino" },
  { value: "FEMININO", label: "Feminino" },
];

export const typePhoneOptions = [
  { value: "RESIDENCIAL", label: "RESIDENCIAL" },
  { value: "COMERCIAL", label: "COMERCIAL" },
  { value: "CELULAR", label: "CELULAR" },
];

export const statusOrders = [
  { value: "CREATED", label: "Criada" },
  { value: "CANCELLED", label: "Cancelada" },
  { value: "FINALIZED", label: "Finalizada" },
];

export const statusOptions = [
  { value: "ATENDEU", label: "Atendeu" },
  { value: "OCUPADO", label: "Ocupado" },
  { value: "INEXISTENTE", label: "Inexistente" },
  { value: "NÃO ATENDEU", label: "Não Atendeu" },
  { value: "CAIXA POSTAL", label: "Caixa Postal" },
];

export const situationOptions = [
  { value: "NOVA", label: "Nova" },
  { value: "USADA", label: "Usada" },
];

export const statusNegotiation = [
  { value: "INICIADA", label: "Iniciada" },
  { value: "PAUSADA", label: "Pausada" },
  { value: "VENDIDA", label: "Vendida" },
  { value: "CANCELADA", label: "Cancelada" },
  { value: "AGUARDANDO_DOCUMENTO", label: "Aguardando Documento" },
  { value: "AGUARDANDO_APROVACAO_BANCARIA", label: "Aguardando Aprovação Bancária" },
];

export const paymentMethod = [
  { value: "FINANCIAMENTO", label: "Financiamento" },
  { value: "A_VISTA", label: "À Vista" },
  { value: "CONSORCIO", label: "Consórcio" },
  { value: "PROGRAMA_GOVERNO", label: "Programa do Governo" },
];
